// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayOfferContainer_container__hbWWT","main":"DisplayOfferContainer_main__otoA0","sticky":"DisplayOfferContainer_sticky__flhIC"};